import failureLogin from '@waiterio/api-client/failureLogin'
import post from '@waiterio/api-client/post'


export default function login (loginRequest) {

	return post({url: 'authentication', body: loginRequest}, failureLogin)

}
